import React, { useEffect, useCallback } from "react";
import renderSelectField from "../../shared/components/form/Select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { getPostcardIssuers } from "./actions/postcardIssuers.actions";

const IssuersDropDown = ({
  postCardIssuers,
  label,
  dispatch,
  disabled,
  onChange,
  id,
  required,
}) => {
  const handleGetPostCardIssuers = useCallback(() => {
    dispatch(getPostcardIssuers());
  }, [dispatch]);

  useEffect(() => {
    handleGetPostCardIssuers();
  }, [handleGetPostCardIssuers]);

  return (
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="issuerNumber"
          customChange={onChange}
          component={renderSelectField}
          options={
            (postCardIssuers.response && postCardIssuers.response.data) || []
          }
          valueKey="issuerNr"
          disabled={disabled}
          labelKey="issuerName"
          placeholder="All banks"
        />
      </div>
      {postCardIssuers && postCardIssuers.error ? (
        <Alert color="danger">
          Could not fetch issuers
          {postCardIssuers.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={handleGetPostCardIssuers}
              className="float-right pointer"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect((state) => ({
  postCardIssuers: state.postCardIssuers,
}))(IssuersDropDown);
